import { Link } from 'react-router-dom';
import { useContext, useEffect } from 'react';
import { CatalogContext } from 'Catalog/Catalog.context';

export default function CatalogLink({
  children,
  to,
  type = 'relative',
  target,
  className,
}) {
  const { lang, setPagingDirection } = useContext(CatalogContext);

  if (type === 'relative') {
    to = `/${lang}/${to}`;
  } else {
    to = to;
  }

  return (
    <Link
      to={to}
      target={target}
      className={className}
      onClick={() => setPagingDirection('jump')}
    >
      {children}
    </Link>
  );
}
